import { CART } from 'cart/constants/entities';

export const CART_BASE = `/cart`;
export const CART_ITEM = `${CART_BASE}/:cartItemId`;

export const entityPathMap = {
  [CART]: {
    cart: CART_BASE,
    cartItem: CART_ITEM
  }
};
